import { BuildingDTO } from "./building";
import { FileLog } from "./file";

export enum PreEmptionRightPresent {
    OK = "Geen voorkooprecht aanwezig",
    NOT_OK = "Wel voorkooprecht aanwezig",
    UNKNOWN = "Onbekend / Nog na te kijken"
}

export enum DominantOrPassiveEstate {
    PASSIVE_ESTATE = "Lijdend erf",
    DOMINANT_ESTATE = "Heersend erf",
    UNKNOWN = "Onbekend / Nog na te kijken"
}

export type BuildingEasement = {
    id: number;
    buildingOwnerShipInfo: BuildingOwnerShipInfo;
    dominantOrPassiveEstate: DominantOrPassiveEstate;
    buildingEasementDescription: string; 
    easementExcerptDescription: string; 
    excerptFileLog: FileLog; 
    excerptFileLogId: number; 
}


export enum EasementCheckStatus {
    OK = "Erfdienstbaarheden nagekeken in laatste notariële akte",
    UNKNOWN = "Onbekend / Nog na te kijken"
}


export type BuildingOwnerShipInfo = {
    id: number;
    building: BuildingDTO;
    buildingId?: string | null;
    buildingDeedsFileLogs: any[];
    buildingDeedsFileLogIds: number[];
    preEmptionRightPresent: PreEmptionRightPresent;
    preEmptionRightPresentDescription: string; 
    easementCheckStatus: EasementCheckStatus;
    easements: BuildingEasement[];
    appraisalFileLogIds: number[];
    appraisalFileLogs: any[];
    appraisalValue: number;
    buildingInsuredValue: number; 
}